import { VerificationStatus } from "shared/types";
import { has } from "shared/utils";
import { AuditSummaryFlag } from "views/applications-id/components/ApplicantsTable/components/AuditSummaryFlag";
import { Cell } from "views/applications-id/components/ApplicantsTable/components/Cell";
import { ReportStatusBadge } from "views/applications-id/components/ApplicantsTable/components/ReportStatusBadge";
import {
  FullApplicant,
  Verification
} from "views/applications-id/components/ApplicantsTable/types";
import {
  calculatePastDueAccounts,
  toMoneyIfExist
} from "views/applications-id/components/ApplicantsTable/utils";

export const CreditReportSection = ({
  applicant,
  scoreBased,
  verification,
  isApplicant,
  ruleBased,
  inProgress,
  hasAuditFlagEnabled
}: {
  applicant: FullApplicant;
  scoreBased?: boolean;
  isApplicant: boolean;
  hasAuditFlagEnabled: boolean;
  ruleBased?: boolean;
  inProgress: boolean;
  verification: Verification;
}) => {
  const pastDueAccounts = calculatePastDueAccounts(verification.summary);

  return (
    <>
      <Cell
        isFirst
        isDataCell
        check={
          verification.status === VerificationStatus.NoDataAvailable ||
          verification.summary?.score === "No data"
            ? null
            : isApplicant &&
                !ruleBased &&
                !inProgress &&
                typeof applicant.criteria_check_settings.credit_score
                  ?.importance === "number"
              ? applicant.criteria_check_settings.credit_score.check
              : null
        }
        className="relative"
      >
        {has(verification.summary?.score) ? (
          verification.summary.score
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
        <ReportStatusBadge
          applicantStatus={applicant.application_status}
          verificationStatus={verification.status}
          executionMode={verification.settings?.execution_mode}
        />
      </Cell>
      <Cell
        isDataCell
        check={
          verification.status === VerificationStatus.NoDataAvailable ||
          pastDueAccounts === "No data"
            ? null
            : isApplicant &&
                !ruleBased &&
                !inProgress &&
                typeof applicant.criteria_check_settings.past_due_account
                  ?.importance === "number"
              ? applicant.criteria_check_settings.past_due_account.check
              : null
        }
      >
        {has(verification.summary) ? (
          calculatePastDueAccounts(verification.summary)
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
      </Cell>
      <Cell
        isDataCell
        check={
          verification.status === VerificationStatus.NoDataAvailable ||
          verification.summary?.balance_past_due === "No data"
            ? null
            : isApplicant &&
                !ruleBased &&
                !inProgress &&
                typeof applicant.criteria_check_settings
                  .unpaid_collections_balance?.importance === "number"
              ? applicant.criteria_check_settings.unpaid_collections_balance
                  .check
              : null
        }
      >
        {has(verification.summary?.balance_past_due) &&
        verification.summary.balance_past_due !== "No data" ? (
          toMoneyIfExist(verification.summary.balance_past_due.cents)
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "No data"
        )}
      </Cell>
      <Cell
        isDataCell
        check={
          verification.status === VerificationStatus.NoDataAvailable
            ? null
            : isApplicant &&
                !ruleBased &&
                !inProgress &&
                typeof applicant.criteria_check_settings.collections_balance
                  ?.importance === "number"
              ? applicant.criteria_check_settings.collections_balance.check
              : null
        }
      >
        {has(verification.summary?.balance_of_collections) &&
        verification.summary.balance_of_collections !== "No data" ? (
          toMoneyIfExist(verification.summary.balance_of_collections.cents)
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "No data"
        )}
      </Cell>
      <Cell
        isDataCell
        check={
          inProgress ||
          verification.status === VerificationStatus.Failed ||
          verification.summary?.bankruptcy === "No data"
            ? null
            : verification.status === VerificationStatus.NoDataAvailable
              ? null
              : isApplicant &&
                  !ruleBased &&
                  typeof applicant.criteria_check_settings.bankruptcy_records
                    ?.importance === "number"
                ? applicant.criteria_check_settings.bankruptcy_records.check
                : null
        }
      >
        {has(verification.summary?.bankruptcy) ? (
          verification.summary.bankruptcy
        ) : hasAuditFlagEnabled ? (
          <AuditSummaryFlag
            audit_summary_flags={applicant.audit_summary_flags}
          />
        ) : (
          "-"
        )}
        {"\n"}
        {scoreBased &&
        verification.summary?.bankruptcy !== "No data" &&
        applicant.template_criteria_settings?.bankruptcy_records
          ? `(${applicant.template_criteria_settings.bankruptcy_records.value} within ${applicant.template_criteria_settings.bankruptcy_records.value} years)`
          : null}
      </Cell>
    </>
  );
};
